import { Suspense, lazy } from 'react';
import '../db/firebaseInit';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import RootContextProvider from '../store/context/rootContext';
import ScrollToTop from '../components/util/ScrollToTop';
import Header from '../components/Header/Header';
import Loader from '../components/util/Loader';

const Footer = lazy(() => import('../components/Footer/Footer'));
const Home = lazy(() => import('../components/Home/Home'));
const Contact = lazy(() => import('../components/contact/Contact'));

//Community
const Community = lazy(() => import('../components/community/Community'));

//medical
const Medical = lazy(() => import('../components/medical/Medical'));
const Pharmacy = lazy(() => import('../components/medical/Pharmacy'));
const CommonMed = lazy(() => import('../components/medical/CommonMed'));
const HospitalDetails = lazy(() => import('../components/medical/Hospital'));
const Doctor = lazy(() => import('../components/medical/Doctor'));
const LabTest = lazy(() => import('../components/medical/LabTest'));
const DoctorDetails = lazy(() => import('../components/medical/DoctorDetails'));
const Appointment = lazy(() => import('../components/medical/Appointment'));
const Order = lazy(() => import('../components/medical/Order'));
const ThankYouMedical = lazy(() => import('../components/medical/ThankYouMedical'));
const DoctorDetailFilter = lazy(() => import('../components/medical/DoctorDetailsFilter'));

//Emergency
const Emergency = lazy(() => import('../components/emergency/Emergency'));
const Police = lazy(() => import('../components/emergency/Police'));
const Ambulance = lazy(() => import('../components/emergency/Ambulance'));
const Fire = lazy(() => import('../components/emergency/FireBrigade'));
const Blood = lazy(() => import('../components/emergency/BloodBank'));
const Hospital = lazy(() => import('../components/emergency/Hospital'));
const Wbsedcl = lazy(() => import('../components/emergency/Wbsedcl'));

//Education
const Education = lazy(() => import('../components/education/Education'));
const Teacher = lazy(() => import('../components/education/Teacher'));

//onboard
const OnBoardEdu = lazy(() => import('../components/onBoard/OnBoardEdu'));
const OnBoardTransport = lazy(() => import('../components/onBoard/OnBoardTransport'));
const OnBoardPharmacy = lazy(() => import('../components/onBoard/OnBoardPharmacy'));
const OnBoardService = lazy(() => import('../components/onBoard/OnBoardService'));
const OnBoardGrocery = lazy(() => import('../components/onBoard/OnBoardGrocery'));
const OnBoardFood = lazy(() => import('../components/onBoard/OnBoardFood'));
const OnBoardBus = lazy(() => import('../components/onBoard/OnBoardBus'));
const OnBoardJob = lazy(() => import('../components/onBoard/OnBoardHiring'));

//Transport
const Transport = lazy(() => import('../components/transport/Transport'));
const Train = lazy(() => import('../components/transport/Train'));
const TrainTime = lazy(() => import('../components/transport/TrainTime'));
const Toto = lazy(() => import('../components/transport/Toto'));
const Car = lazy(() => import('../components/transport/Car'));
const Bus = lazy(() => import('../components/transport/Bus'));
const BusTime = lazy(() => import('../components/transport/BusTime'));

//Service
const CommonService = lazy(() => import('../components/service/CommonService'));

//Building
const Building = lazy(() => import('../components/building/Building'));
//Fashion
const Fashion = lazy(() => import('../components/fashion/Fashion'));
//Digital
const Digital = lazy(() => import('../components/digital/Digital'));
const DigitalGovt = lazy(() => import('../components/digital/Govt'));

//Grocery
const Grocery = lazy(() => import('../components/grocery/Grocery'));
const GroceryScreen = lazy(() => import('../components/grocery/GroceryScreen'));

//food
const Food = lazy(() => import('../components/food/Food'));
const FoodScreen = lazy(() => import('../components/food/FoodScreen'));

//Product
const Product = lazy(() => import('../components/product/Product'));
const ProductOrder = lazy(() => import('../components/product/Order'));

//Job
const Job = lazy(() => import('../components/hiring/Hire'));

//hospitality
const Hospitality = lazy(() => import('../components/hospitality/Hospitality'));
// const FoodScreen = lazy(() => import('../components/food/FoodScreen'));

//util
const ComingSoon = lazy(() => import('../components/util/ComingSoon'));
const ThankYou = lazy(() => import('../components/util/ThankYou'));

//Admin
const Admin = lazy(() => import('../components/admin/Admin'));
const AdminTutor = lazy(() => import('../components/admin/Tutor'));
const AdminPharmacy = lazy(() => import('../components/admin/Pharmacy'));
const AdminTransport = lazy(() => import('../components/admin/Transport'));
const AdminService = lazy(() => import('../components/admin/Service'));
const AdminGrocery = lazy(() => import('../components/admin/Grocery'));
const AdminFood = lazy(() => import('../components/admin/Food'));
const AdminHire = lazy(() => import('../components/admin/Hire'));

//Auth
const Login = lazy(() => import('../components/auth/Login'));
const ForgetPassword = lazy(() => import('../components/auth/ForgetPassword'));
const Auth = lazy(() => import('../components/auth/Auth'));

//User
const UserScreen = lazy(() => import('../components/user/UserScreen'));
const CommonEdit = lazy(() => import('../components/user/CommonEdit'));

function App() {

  return (
    <div className="App">
      <RootContextProvider>
        <BrowserRouter>
          <Header />
          <div style={{ marginTop: '3.6rem' }}></div>
          <Suspense fallback={<Loader />}>
            <ScrollToTop />
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/contact' element={<Contact />} />

              <Route path='/medical' element={<Medical />} />
              <Route path='/medical/pharmacy' element={<Pharmacy />} />
              <Route path='/medical/common/:type' element={<CommonMed />} />
              <Route path='/medical/hospital' element={<HospitalDetails />} />
              <Route path='/medical/doctor' element={<Doctor />} />
              <Route path='/medical/doctorDetails' element={<DoctorDetails />} />
              <Route path='/medical/order' element={<Order />} />
              <Route path='/medical/labTest' element={<LabTest />} />
              <Route path='/medical/thankYou' element={<ThankYouMedical />} />
              <Route path='/medical/doctor/doctorDetails/:spec' element={<DoctorDetailFilter />} />
              <Route path='/medical/appointment' element={<Appointment />} />

              <Route path='/emergency' element={<Emergency />} />
              <Route path='/emergency/police' element={<Police />} />
              <Route path='/emergency/fire' element={<Fire />} />
              <Route path='/emergency/ambulance' element={<Ambulance />} />
              <Route path='/emergency/transport' element={<Transport />} />
              <Route path='/emergency/blood' element={<Blood />} />
              <Route path='/emergency/hospital' element={<Hospital />} />
              <Route path='/emergency/wbsedcl' element={<Wbsedcl />} />

              <Route path='/education' element={<Education />} />
              <Route path='/education/teacher' element={<Teacher />} />

              <Route path='/transport' element={<Transport />} />
              <Route path='/transport/train' element={<Train />} />
              <Route path='/transport/train/:id' element={<TrainTime />} />
              <Route path='/transport/toto' element={<Toto />} />
              <Route path='/transport/car' element={<Car />} />
              <Route path='/transport/bus' element={<Bus />} />
              <Route path='/transport/bus/:direction' element={<BusTime />} />


              <Route path='/service/:section/:type' element={<CommonService />} />

              <Route path='/building' element={<Building />} />
              <Route path='/fashion' element={<Fashion />} />
              <Route path='/digital' element={<Digital />} />
              <Route path='/digital/govt' element={<DigitalGovt />} />

              <Route path='/grocery' element={<Grocery />} />
              <Route path='/grocery/board/:type' element={<GroceryScreen />} />

              <Route path='/food' element={<Food />} />
              <Route path='/food/board/:type' element={<FoodScreen />} />

              <Route path='/product' element={<Product />} />
              <Route path='/product/order' element={<ProductOrder />} />

              <Route path='/job' element={<Job />} />

              <Route path='/hospitality' element={<Hospitality />} />
              <Route path='/hospitality/board/:type' element={<Hospitality />} />

              <Route path='/onboard/tutor' element={<OnBoardEdu />} />
              <Route path='/onboard/transport' element={<OnBoardTransport />} />
              <Route path='/onboard/pharmacy' element={<OnBoardPharmacy />} />
              <Route path='/onboard/service' element={<OnBoardService />} />
              <Route path='/onboard/grocery' element={<OnBoardGrocery />} />
              <Route path='/onboard/food' element={<OnBoardFood />} />
              <Route path='/onboard/bus' element={<OnBoardBus />} />
              <Route path='/onboard/job' element={<OnBoardJob />} />

              <Route path='/comingSoon' element={<ComingSoon />} />
              <Route path='/thankYou' element={<ThankYou />} />

              <Route path='/community' element={<Community />} />

              <Route path='/admin' element={<Auth><Admin /></Auth>} />
              <Route path='/admin/tutor' element={<Auth><AdminTutor /></Auth>} />
              <Route path='/admin/pharmacy' element={<Auth><AdminPharmacy /></Auth>} />
              <Route path='/admin/transport' element={<Auth><AdminTransport /></Auth>} />
              <Route path='/admin/service' element={<Auth><AdminService /></Auth>} />
              <Route path='/admin/grocery' element={<Auth><AdminGrocery /></Auth>} />
              <Route path='/admin/food' element={<Auth><AdminFood /></Auth>} />
              <Route path='/admin/hire' element={<Auth><AdminHire /></Auth>} />

              <Route path='/user/:type' element={<Auth><UserScreen /></Auth>} />
              <Route path='/user/:section/:type/edit' element={<Auth><CommonEdit /></Auth>} />

              <Route path='/login' element={<Login />} />
              <Route path='/forgetPassword' element={<ForgetPassword />} />
              <Route path='*' element={<Navigate to="/" />} />
            </Routes>
            <Footer />
          </Suspense>
        </BrowserRouter>
      </RootContextProvider>

    </div>
  );
}

export default App;
